import React from "react";

const Footer = () => {
  return (
    <>
      <footer class="bg-gray-800 text-white py-4">
        <div class="container mx-auto">
          <div class="flex flex-col  justify-between items-center">
            <div class="mr-4">
             Made with ❤️ by Devesh 
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
